<template>
  <b-modal
    id="add-checkbox-brand"
    size="xl"
    centered
    no-close-on-backdrop
    @hide="onHideModal"
    title="Add/Edit Register Checkbox - Brand"
  >
    <form id="add-banner-form" @submit.prevent="submit">
      <div class="col-md-12">
        <b-form-group label="Select Project">
          <b-form-select
            class="select col-12"
            :class="{ 'has-error': !validateProject }"
            v-model="data.project_id"
          >
            <option :value="null" disabled>-- Please select project --</option>
            <!-- <template  v-if="showProject(projectData)">
              <option
                v-for="projectData in projectList"
                :value="projectData.id"
                :key="projectData.id"
              >
                {{ projectData.name.th }}
              </option>
            </template> -->
            <template v-for="projectData in projectList">
              <option
                v-if="showProject(projectData)"
                :key="projectData.id"
                :value="projectData.id"
              >
                {{ projectData.name.th }}
              </option>
            </template>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="flex-row col-md-12">
        <div class="thumbnail-picker-wrapper">
          <ImageUploadNew
            :isRequired="false"
            :maxFile="1"
            :uploadSetting="{ ...uploadSetting }"
            :dataImage="{ ...image }"
            :showError="uploadImgError"
            :onFileUploaded="onFileUploadImage"
          />
        </div>
        <div class="flex-1">
          <b-form-group
            style="font-weight: 600"
            label="Thumbnail (500 x 280 pixel)"
          >
            <div class="flex-row">
              <p style="margin-right: 5px; flex: 1 10%" class="alt-thumb">
                ALT Text
              </p>
              <b-form-input
                type="text"
                placeholder="Typing Something..."
                v-model="data.image.alt"
              ></b-form-input>
            </div>
          </b-form-group>
        </div>
      </div>
    </form>
    <template slot="modal-footer">
      <b-button size="sm" variant="primary" type="submit" form="add-banner-form"
        >Save</b-button
      >
      <b-button size="sm" variant="danger" @click="onHideModal"
        >Cancel</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import ImageUploadNew from '../ImageUploadNew'
import { mapActions } from 'vuex'
import { ActionFetch } from '@/store/actionTypes'

export default {
  props: {
    categoryID: Number,
    data: Object,
    registerProjectList: Array,
    onSubmitForm: Function,
  },
  components: {
    ImageUploadNew,
  },
  data: () => ({
    uploadSetting: {
      showPreview: false,
      showDelete: true,
      showAlt: false,
    },
    validateProject: true,
    uploadImgError: false,
    projectList: [],
    image: {
      source: '',
      name: '',
    },
  }),
  methods: {
    ...mapActions({
      getProjectList: ActionFetch.PROJECTS.MAIN.INDEX,
    }),
    onHideModal() {
      this.validateProject = true
      this.uploadImgError = false
      this.$bvModal.hide('add-checkbox-brand')
    },
    fetchProject() {
      const condition = {
        cid: this.categoryID,
        apiVersion: '/v1',
      }
      this.getProjectList(condition).then(($res) => {
        this.projectList = $res.data
      })
    },
    showProject($project) {
      const project = this.registerProjectList.find(($reg) => {
        return (
          $reg.project_id === $project.id &&
          this.data.project_id !== $project.id
        )
      })

      return !project
    },
    onFileUploadImage($value) {
      this.data.image.filename = $value.source
      this.image = $value
    },
    submit($e) {
      $e.preventDefault()
      this.uploadImgError = !this.data.image.filename
      this.validateProject = !!this.data.project_id

      if (this.validateProject && !this.uploadImgError) {
        this.onSubmitForm(this.data)
        this.$bvModal.hide('add-checkbox-brand')
      }
    },
  },
  watch: {
    categoryID: function (newValue) {
      this.fetchProject()
    },
    'data.image': function (value) {
      this.image = {
        source: value.filename,
        name: value.alt,
      }
    },
    registerProjectList: function (value) {
      this.fetchProject()
    },
  },
  created() {
    this.fetchProject()
  },
}
</script>

<style scoped>
.file-name {
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: #666666;
  margin-left: 10px;
}
.p-icon {
  min-width: 100px;
}
</style>
